<template>
  <div class="login-container">
    <div class="login-form">
      <div class="card">
        <div class="card-header">
          <a href="#" class="logo-link">
            <img src="@/assets/img/logo_jtb.png" alt="Logo" />
          </a>
          <div class="text-login">{{ $t("general.system_name") }}</div>
        </div>
          <div class="card-body">
            <div class="form-box">
              <!-- シークレットキー-->
              <div class="text-center mt-1 font-weight-bold">
                <div style="font-size: 13px; font-weight: 300" v-html="$t('login.sp_input_code_message')" />
              </div>

              <div class="mt-4" style="font-size:14px">シークレットキー:</div>
              <div class="d-flex align-items-center justify-content-center mb-3">
                <span style="width: 300px;">{{ secretKey }}</span>
                <button class="btn btn-clipboard-cir mt-3" type="button" style="display:inline-flex;color:white" @click="copyToClipboard(secretKey)">
                  <div style="display: contents;">
                    <i class="icon-copy-orange"></i>
                  </div>
                </button>
              </div>

              <!--戻る/次へボタン-->
              <div class="mt-3 d-flex">
                <button
                  class="btn btn-pink-53 w-100"
                  @click="next()"
                >
                  {{ $t("button.next") }}
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import StorageService from "@/services/common/storage.service";
import { Role } from "@/helpers/role";
import store from "../../../../store";
import router from "../../../../router";

export default {
  name: "SpLoginFirstMfa",
  data() {
    return {
      errorMessage: "",
      username: "",
      placeId: "",
      clickChangePass: false,
    };
  },
  beforeMount () {
      let token = StorageService.getToken();
      if (token) {
          const role = StorageService.getUserRole();
          if (role == Role.PwReset.id) {
              this.errorMessage = this.$root.$t("error.error_pwrest");
          } else {
              router.push("/");
          }
      }
      let remember = JSON.parse(StorageService.getRememberMe());
      if (remember) {
          this.username = remember.username;
          this.password = remember.password;
          //this.placeId = remember.placeId;
          this.rememberMe = remember.rememberMe;
      }
  },
  mounted() {
    this.username = this.$route.query.username;
    this.placeId = this.$route.query.placeId;
    this.clickChangePass = StorageService.getClickChangePass();
    let isExpired = StorageService.getExpired();
    if (isExpired) {
        this.errorMessage = this.$root.$t("error.error_expired");
        StorageService.removeExpired();
    }
  },
  created() {
    store.state.secretKey ? '' : router.push("/");
  },
  methods: {
    copyToClipboard(secretKey){
      //クリップボードへのコピーをするための一時的なDOM制御
      const copyFrom = document.createElement("textarea");
      copyFrom.textContent = secretKey;
      const bodyElm = document.getElementsByTagName("body")[0];
      bodyElm.appendChild(copyFrom);
      copyFrom.select();
      const retVal = document.execCommand('copy');
      bodyElm.removeChild(copyFrom);
      this.alert_success = this.$t('user.copy_secret_key.title')
      this.$toasted.success(this.alert_success, {icon: 'fa-check'});
      return retVal;
  },

    next() {
      router.push({path: '/login/mfa', query: {username: this.username, placeId: this.placeId}});
    }
  },
  computed: {
    secretKey() {
      return store.state.secretKey
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Login/LoginFirstMfa.vue